import left from './left.svg'
import right from './right.svg'
import center from './center.svg'

export default { left, right, center }
